import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.css']
})
export class BlogListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  blogs = [
    {
      image: "assets/images/mental-health-word-from-wooden-letters-mental-hea-2023-11-27-05-03-37-utc.jpg",
      // day: "13",
      // month: "July",
      // field: "Factory",
      title: "Why Mental Health Should Be a Priority in Schools?",
      description: "A school is not just a place for academic growth; it’s a space where minds are nurtured, emotions are balanced, and futures are shaped.",
      // description1: "When you think of schools, what comes to mind? Grades, sports, extracurriculars, and achievements, right? But there’s another critical aspect often overlooked—mental health. While academic success is important, it means little if a student is struggling emotionally.",
      linkToReadMore: "/priority-schools"
    },
    {
      image: "assets/images/asian-indian-schoolboy-and-schoolgirl-in-uniforms-2025-01-16-13-05-29-utc (1).jpeg",
      // day: "13",
      // month: "July",
      // field: "Factory",
      title: "Recognizing Early Signs of Mental Health Issues in Children.",
      description: "Children don’t always have the words to explain how they feel—but their actions often tell the story.",
      linkToReadMore: "/issues-children"
    },
    {
      image: "assets/images/shes-victim-of-bullying-2023-11-27-05-31-36-utc.jpg",
      // day: "13",
      // month: "July",
      // field: "Factory",
      title: "Dealing with Peer Pressure and Social Anxiety in School.",
      description: "It’s hard to stand out when you’re afraid of not fitting in.",
      linkToReadMore: "/anxiety-school"
    },
    {
      image: "assets/images/schoolboy-and-his-friends-meditating-while-practic-2024-12-13-22-21-16-utc.jpg",
        // day: "13",
        // month: "July",
        // field: "Factory",
      title: "Teaching Emotional Regulation to Students: Techniques That Work.",
      description: "When students learn to manage their emotions, they unlock their true potential.",
      linkToReadMore: "/techniques-work"
    },
    {
      image: "assets/images/happy-schoolchildren-in-formal-wear-holding-cards-2024-11-17-07-45-42-utc.jpg",
        // day: "13",
        // month: "July",
        // field: "Factory",
      title: "Mindfulness Practices for Schools: Helping Students Stay Focused.",
      description: "When students learn to manage their emotions, they unlock their true potential.",
      linkToReadMore: "/selping-students"
    }
  ];

  // author = {
  //   title: "About Author",
  //   image: "assets/images/team/pic1.jpg",
  //   name: "Rosalina D. Willaimson",
  //   description: "We are the dolor sit ametLorem Ipsum Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin.",
  //   fb: "https://www.facebook.com",
  //   twitter: "https://twitter.com",
  //   linkedin: "https://in.linkedin.com",
  //   pin: "https://in.pinterest.com"
  // };

  // recentPosts = [
  //   {
  //     title: "Recent Posts",
  //     posts: [
  //       {
  //         image: "assets/images/blog/recent-blog/pic1.jpg",
  //         date: "18 Apr, 2021",
  //         title: "Automating The Design to Manufacturing Lifecycle.",
  //         postLink: "/blog-single"
  //       },
  //       {
  //         image: "assets/images/blog/recent-blog/pic2.jpg",
  //         date: "24 Apr, 2021",
  //         title: "Fusce ac tellus ut libero ullamcorper maximus.",
  //         postLink: "/blog-single"
  //       },
  //       {
  //         image: "assets/images/blog/recent-blog/pic3.jpg",
  //         date: "30 Apr, 2021",
  //         title: "In eleifend lobortis tortor, at ornare tellus cursus quis.",
  //         postLink: "/blog-single"
  //       }
  //     ]
  //   }
  // ];

  // instagramPosts = [
  //   {
  //     image: "assets/images/insta-pic/1.jpg",
  //     link: "/blog-single"
  //   },
  //   {
  //     image: "assets/images/insta-pic/2.jpg",
  //     link: "/blog-single"
  //   },
  //   {
  //     image: "assets/images/insta-pic/3.jpg",
  //     link: "/blog-single"
  //   },
  //   {
  //     image: "assets/images/insta-pic/4.jpg",
  //     link: "/blog-single"
  //   },
  //   {
  //     image: "assets/images/insta-pic/5.jpg",
  //     link: "/blog-single"
  //   },
  //   {
  //     image: "assets/images/insta-pic/6.jpg",
  //     link: "/blog-single"
  //   }
  // ];

  // categories = [
  //   {
  //     title: "Oil, Gas & Coal",
  //     badge: "28",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Mechanical Engineering",
  //     badge: "28",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Chemical Research",
  //     badge: "05",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Construction Industry",
  //     badge: "24",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Electrical Engineering",
  //     badge: "15",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Petroleum Refinery",
  //     badge: "20",
  //     link: "/blog-single"
  //   }
  // ];

  // tags = [
  //   {
  //     title: "Build",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Factory",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Engineering",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Repairing",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Industry",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Materials",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Mechanical",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Buildings",
  //     link: "/blog-single"
  //   },
  //   {
  //     title: "Construction",
  //     link: "/blog-single"
  //   }
  // ];
}
